import { action as apiAction } from 'api/Api'
import {
  removeCardRelation
} from 'store/redux/cardRelations'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  predecessorId: number
  successorId: number
}

const requestRemoveCardSequence = (payload: Payload) => async (dispatch, getState) => {
  const { predecessorId, successorId } = payload

  const optimisticAction = optimisticDispatch(dispatch, [
    removeCardRelation({
      id: predecessorId,
      successorIds: [successorId]
    }),
    removeCardRelation({
      id: successorId,
      predecessorIds: [predecessorId]
    })
  ])

  try {
    await apiAction('RemoveCardSuccessor', {
      succCardId: successorId,
      predCardId: predecessorId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code === 506) {
      const state = getState()

      try {
        await sweetalert({
          text: state.kanbo.locale.messages['CARD_RELATION_REMOVE_ARCHIVED_CARD'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}

export default requestRemoveCardSequence
